import { RAW_COLORS } from '@pixee/design-system/primitives'

// Drawn inline rather than shipped as an SVG asset so the tile and glyph read the brand tokens; an asset
// would pin copies of their values. The tile stays Haze in both themes: it is a brand mark on its own
// tile, unlike the theme-aware Findings intake color in the composition bar.
export const FindingsIntakeIcon: React.FC<React.ComponentProps<'svg'>> = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" {...props}>
    <rect width="256" height="256" rx="56" fill={RAW_COLORS.secondary.haze} />
    <path
      transform="translate(12.8 12.8) scale(0.9)"
      fill={RAW_COLORS.neutral.orbit}
      d="M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM90.34,114.34a8,8,0,0,1,11.32,0L120,132.69V72a8,8,0,0,1,16,0v60.69l18.34-18.35a8,8,0,0,1,11.32,11.32l-32,32a8,8,0,0,1-11.32,0l-32-32A8,8,0,0,1,90.34,114.34ZM208,208H48V168H76.69L96,187.32A15.890,15.89,0,0,0,107.31,192h41.38A15.86,15.86,0,0,0,160,187.31L179.31,168H208v40Z"
    />
  </svg>
)
